import React, { useEffect, useState } from "react";
import "./sidebar.scss";
import Dropdown from "./Dropdown";
import { ReactComponent as RugbyIcon } from "assets/svg/rugby.svg";
import { useSearchParams } from "react-router-dom";
import { toLower } from "lodash";

// Restricted sidebar for the commentary panel: only Rugby League and Rugby
// Union, each exposing a single Matches link into the commentary matches page.
const rugbyLeagueCommentary = [
  { title: "Matches", path: "/commentary/matches?sport=rugby-league" },
];

const rugbyUnionCommentary = [
  { title: "Matches", path: "/commentary/matches?sport=rugby-union" },
];

const CommentarySidebar = () => {
  const [searchParams] = useSearchParams();
  const sport = searchParams.get("sport");
  const [currentMenu, setCurrentMenu] = useState(toLower(sport));

  useEffect(() => {
    setCurrentMenu(toLower(searchParams.get("sport") || "rugby-league"));
  }, [searchParams, sport]);

  return (
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-dark"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu">
            <Dropdown
              title="Rugby League"
              list={rugbyLeagueCommentary}
              status={currentMenu === "rugby-league"}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="rugby-league"
            >
              <RugbyIcon className="me-1" />
            </Dropdown>

            <Dropdown
              title="Rugby Union"
              list={rugbyUnionCommentary}
              status={currentMenu === "rugby-union"}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="rugby-union"
            >
              <RugbyIcon className="me-1" />
            </Dropdown>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default CommentarySidebar;
